import React from 'react';
import styles from './ModalButton.module.scss';

export class ModalButton extends React.Component {
    render() {
        const {
            label,
            handleClick
        } = this.props;
        return (
            <button className={styles["button"]} onClick={handleClick} data-autoamtion-id="modal-button">
                {label}
            </button>
        )
    }

}


ModalButton.propTypes = {};

export default ModalButton;